import { GetPriceResult } from './types'
import { Token } from '@/domain/types/Token'
import { BaseUnitNumber } from '@/domain/types/NumericValues'

export function estimateUSDDifference(priceData: GetPriceResult): string {
  const inputAmountUSD = Number(priceData.result.inputAmountUSD)
  const outputAmountUSD = Number(priceData.result.effectiveOutputAmountUSD)
  const percentageDifference = ((outputAmountUSD - inputAmountUSD) / inputAmountUSD) * 100
  const formattedPercentageDifference = `${percentageDifference >= 0 ? '+' : ''}${percentageDifference.toFixed(2)}%`
  return formattedPercentageDifference
}

export function estimateTokenRatio({
  priceData,
  fromToken,
  toToken,
}: { priceData: GetPriceResult; fromToken: Token; toToken: Token }): string {
  const inputBaseAmount = BaseUnitNumber(priceData.result.inputAmount)
  const outputBaseAmount = BaseUnitNumber(priceData.result.outputAmount)

  const normalizedInputAmount = Number(fromToken.fromBaseUnit(inputBaseAmount))
  const normalizedOutputAmount = Number(toToken.fromBaseUnit(outputBaseAmount))

  const ratio = normalizedOutputAmount / normalizedInputAmount

  return ratio.toFixed(6)
}
